import { PlantId } from '../types/plantTypes';

export const asId = (id?: number | string | null): PlantId | null => {
  return id ? id.toString() : null;
};
